import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

type LayoutProps = { logo: string };

const Layout = ({ logo }: LayoutProps) => {
  return (
    <div className="text-zinc-700">
      <Header logo={logo} />
      <div className="outlet p-2">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
